import * as React from "react"
import * as styles from "./SecondTitle.module.scss"
import BackButton from "../BackButton/BackButton"


type SecondTitleProps = {
	desktopImage: string
	mobileImage?: string
	title: string
	position?: string
	back?: "white" | "dark"
	titleColor?: string
}

const SecondTitle: React.FC<SecondTitleProps> = (
	{
		desktopImage,
		mobileImage,
		title,
		back,
		position,
		titleColor = "light",
	}) => {
	const [isMobile, setIsMobile] = React.useState(false)

	React.useEffect(() => {
		const checkScreen = () => setIsMobile(window.innerWidth <= 600)
		checkScreen()
		window.addEventListener("resize", checkScreen)
		return () => window.removeEventListener("resize", checkScreen)
	}, [])

	const originalImage = isMobile && mobileImage ? mobileImage : desktopImage

	// Формируем путь к webp версии (заменяем расширение на .webp)
	const webpImage = originalImage.replace(/\.(jpg|jpeg|png)$/i, ".webp")

	return (
		<div
			className={styles.titleBlock}
			style={{
				backgroundImage:
					`url(${originalImage})`,
				backgroundSize: "cover",
				backgroundPosition: position,
				backgroundRepeat: "no-repeat"
			}}
		>
			{back && <BackButton back={back} />}
			<h1 className={`${styles.title} ${styles[titleColor]}`}>{title}</h1>
		</div>
	)
}

export default SecondTitle
